import { toast as sonnerToast } from "sonner";

// Adapter to make sonner work with the existing toast API
export const useToast = () => {
  return {
    toast: ({ title, description, variant }) => {
      if (variant === "destructive") {
        sonnerToast.error(title, { description });
      } else {
        sonnerToast.success(title, { description });
      }
    },
    dismiss: (id) => sonnerToast.dismiss(id)
  };
};

export const toast = ({ title, description, variant }) => {
  if (variant === "destructive") {
    sonnerToast.error(title, { description });
  } else {
    sonnerToast.success(title, { description });
  }
};